var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    { staticClass: "ma-5", attrs: { flat: "", loading: _vm.loading } },
    [
      _c("v-card-subtitle", [
        _c("span", { staticClass: "text-body-1 mt-1" }, [
          _c("strong", [_vm._v(_vm._s(_vm.$t("sip-domain")) + ":")]),
          _vm._v(
            " " +
              _vm._s(_vm.sipDomain || _vm.$t("no-sip-domain").toUpperCase()) +
              " "
          ),
        ]),
      ]),
      _c("v-divider"),
      _c(
        "v-card-text",
        { staticClass: "mt-n2", style: _vm.sipListStyle },
        [
          _c(
            "v-list",
            [
              _vm._l(_vm.sipUsers, function (item) {
                return [
                  _c(
                    "v-list-item",
                    { key: item.sipSid, staticClass: "no-hover" },
                    [
                      _c("sip-user", {
                        attrs: {
                          user: item,
                          selected: _vm.selected.includes(item.sipSid),
                        },
                        on: {
                          checkboxChanged: _vm.updateSelected,
                          onEdit: _vm.openEditDialog,
                        },
                      }),
                    ],
                    1
                  ),
                ]
              }),
            ],
            2
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-actions",
        { staticClass: "flex-wrap sip-actions" },
        [
          _c("v-spacer"),
          _c(
            "v-btn",
            {
              class: {
                "text-white": _vm.sipDomain?.length && _vm.selected?.length,
              },
              attrs: {
                disabled: _vm.disableDeleteUserButton,
                color: "primary",
              },
              on: { click: _vm.deleteSipUser },
            },
            [_vm._v(" " + _vm._s(_vm.$t("delete-sip-user")) + " ")]
          ),
          _c(
            "v-btn",
            {
              attrs: {
                disabled: _vm.disableCreateSipDomainButton,
                color: "primary",
              },
              on: { click: _vm.createSipDomain },
            },
            [_vm._v(" " + _vm._s(_vm.$t("create-sip-domain")) + " ")]
          ),
          _c(
            "v-btn",
            {
              attrs: {
                disabled: _vm.disableCreateSipUserButton,
                color: "primary",
              },
              on: { click: _vm.createSipUser },
            },
            [_vm._v(" " + _vm._s(_vm.$t("create-sip-user")) + " ")]
          ),
        ],
        1
      ),
      _c("confirmation-dialog", {
        ref: "dialogRef",
        attrs: { "content-class": "devops-subdialog" },
      }),
      _c("create-sip-user-dialog", {
        attrs: { groups: _vm.allGroupsList },
        on: { getUsers: _vm.getSipUsers },
        model: {
          value: _vm.createSipUserDialog,
          callback: function ($$v) {
            _vm.createSipUserDialog = $$v
          },
          expression: "createSipUserDialog",
        },
      }),
      _c("edit-sip-user-dialog", {
        attrs: { user: _vm.editingUser, groups: _vm.allGroupsList },
        on: { updated: _vm.getSipUsers },
        model: {
          value: _vm.editSipUserDialog,
          callback: function ($$v) {
            _vm.editSipUserDialog = $$v
          },
          expression: "editSipUserDialog",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }